import Api from '@/service/api';


async function isValidSession(session) {
  try {
    await Api.get({
      url: 'is-authenticated',
      data: {
        session,
      },
      preloader: false,
    });
  } catch (error) {
    return false;
  }

  return true;
}

export default isValidSession;
